// extracted by css-extract-rspack-plugin
export default {"productSliderSkeletonBorder":"recommendation-fragment__SkeletonTile_productSliderSkeletonBorder__vchs5","w30":"recommendation-fragment__SkeletonTile_w30__auUXf"};